<template>
  <b-modal
    id="modalSaveCalculationProductionCreateWorker"
    v-model="localActive"
    centered
    hide-footer
    hide-header
    @show="onShowModal"
    @close="localActive = false"
  >
    <div class="m-create-worker">
      <svg
        class="m-create-worker-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-create-worker-title">{{ modalTitle }}</div>

      <div class="m-create-worker-inputs">
        <c-input-old
          v-model="fullNameLocal"
          class="m-create-worker-inputs-fullname"
          :class="{ 'm-create-worker-inputs-fullname-required': fullNameErrorMessageLocal.length > 0 }"
          :clearable="true"
          floating-label="ФИО сотрудника"
          :required="fullNameErrorMessageLocal"
        />
        <div v-if="!isDeliveryTab" class="m-create-worker-inputs-row">
          <c-input-old
            v-model="postLocalValue"
            type="select"
            :items="postLocalItems"
            :required="postErrorMessageLocal"
            class="m-create-worker-inputs-row-post"
            :class="{ 'm-create-worker-inputs-row-post-required': postErrorMessageLocal.length > 0 }"
            :clearable="true"
            :searchable="true"
            floating-label="Должность"
          />
          <c-input-old
            v-model="rankLocalValue"
            type="select"
            :items="postLocalValue !== null ? postLocalValue.categories : []"
            class="m-create-worker-inputs-row-rank"
            :class="{
              'm-create-worker-inputs-row-rank-disabled':
                postLocalValue === null || postLocalValue.categories.length === 0,
            }"
            :clearable="true"
            floating-label="Разряд"
          />
        </div>
      </div>

      <div class="m-create-worker-actions">
        <c-button size="large" class="m-create-worker-actions-cancel" label="Отменить" @click="closeModal" />
        <c-button
          class="m-create-worker-actions-save"
          label="Сохранить"
          color="blue"
          size="large"
          @click="submitCreateWorker"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import InputOld from "@/components/controls/input-old";
import Button from "@/components/controls/button";

export default {
  name: "m-completely-relieve-load",

  components: {
    "c-input-old": InputOld,
    "c-button": Button,
  },

  props: ["active", "data", "isDeliveryTab", "calculationType", "modalTitle"],

  data() {
    return {
      localActive: false,
      fullNameLocal: "",
      fullNameErrorMessageLocal: "",
      postLocalValue: null,
      postErrorMessageLocal: "",
      postLocalItems: [],
      rankLocalValue: null,
      submitAttempt: false,
    };
  },

  watch: {
    fullNameLocal(value) {
      if (this.submitAttempt) {
        if (value.length === 0) {
          this.fullNameErrorMessageLocal = "Обязательное поле";
        } else {
          this.fullNameErrorMessageLocal = "";
        }
      }
    },
    postLocalValue(postValue) {
      if (postValue !== null) {
        this.rankLocalValue = null;
        this.rankLocalItems = [];
        const productionPost = this.data.settings.production[postValue.value];
        if (productionPost && productionPost.categories) {
          Object.entries(productionPost.categories).forEach(([rankId, rank]) => {
            this.rankLocalItems.push({ label: rank.number, value: rankId });
          });
        }
        const [firstRank] = this.rankLocalItems;
        this.rankLocalValue = firstRank;
      }

      if (this.submitAttempt) {
        if (postValue === null) {
          this.postErrorMessageLocal = "Обязательное поле";
        } else {
          this.postErrorMessageLocal = "";
        }
      }

      if (postValue === null) {
        this.rankLocalValue = null;
      }
    },
    localActive(value) {
      if (!value) {
        this.$emit("close");
        setTimeout(() => {
          this.submitAttempt = false;
          this.fullNameLocal = "";
          this.postLocalValue = null;
          this.rankLocalValue = null;
          this.postErrorMessageLocal = "";
          this.fullNameErrorMessageLocal = "";
        }, 200);
      }
    },
    active(value) {
      this.localActive = value;
    },
    data(value) {
      if (!this.isDeliveryTab) {
        this.postLocalItems = value.posts.map((post) => {
          const categories = [];

          if (this.data.settings.production[post.code] && this.data.settings.production[post.code].categories) {
            Object.entries(this.data.settings.production[post.code].categories).forEach(
              ([category_id, categoryData]) => {
                categories.push({
                  label: categoryData.number,
                  value: category_id,
                  s: categoryData.s,
                });
              },
            );
          }

          return {
            label: post.name,
            value: post.code,
            categories,
          };
        });

        this.postLocalItems.sort((a, b) => a.label.localeCompare(b.label));
      }
    },
  },

  methods: {
    handleScroll(e) {
      this.scrolled = e.target.scrollTop > 0;
    },
    closeModal() {
      this.localActive = false;
      setTimeout(() => {
        this.rankLocalValue = null;
        this.postErrorMessageLocal = "";
        this.postLocalValue = null;
        this.fullNameLocal = "";
        this.fullNameErrorMessageLocal = "";
        this. tAttempt = false;
      }, 200);
    },
    onShowModal() {},
    cancel() {},
    submitCreateWorker() {
      let isValidForm = true;

      if (this.fullNameLocal.length === 0) {
        this.submitAttempt = true;
        this.fullNameErrorMessageLocal = "Обязательное поле";
        isValidForm = false;
      }

      if (!this.isDeliveryTab) {
        if (this.postLocalValue === null) {
          this.submitAttempt = true;
          this.postErrorMessageLocal = "Обязательное поле";
          isValidForm = false;
        }
      }

      if (isValidForm) {
        let filial_id = 0;
        let calc_id = 0;
        let smena = 0;
        let date = null;
        if (this.calculationType === "byPeriod") {
          filial_id = this.data.period.calculation.filialID
            ? this.data.period.calculation.filialID
            : this.data.period.calculation.filial_id;

          if (!this.isDeliveryTab) {
            if (this.rankLocalValue === null || this.rankLocalValue === undefined) {
              this.$notify({
                group: "error-message",
                data: {
                  textMessage: `Поле <b>рязряд</b> обязательно. Для должности <b>${this.postLocalValue.label}</b> необходимо добавить справочные значения разрядов.`,
                },
              });
              return;
            }
          }
        } else {
          filial_id = this.data.calc.calculation.filial_id;
          calc_id = this.data.calc.calculation.id;
          smena = this.data.calc.calculation.smena;
          date = this.data.calc.calculation.date ? this.data.calc.calculation.date : this.data.calc.calculation.datetime;
        }

        this.$store
          .dispatch("calculations/addWorkerInCalculation", {
            name: this.fullNameLocal,
            post_code: this.isDeliveryTab ? "driver" : this.postLocalValue.value,
            filial_id,
            date,
            smena,
            calc_id,
            type: this.calculationType,
            category_id:
              this.rankLocalValue !== null && this.rankLocalValue !== undefined ? this.rankLocalValue.value : "",
          })
          .then((res) => {
            if (this.calculationType === "byPeriod") {
              if (this.isDeliveryTab) {
                const workerData = {
                  author_bonus: 0,
                  author_fine: 0,
                  bonus_id: 0,
                  bonuses: [],
                  count_smenas: 0,
                  departure: 0,
                  distance: 0,
                  duration: 0,
                  fine_id: 0,
                  fines: [],
                  orders: 0,
                  orders_sum: 0,
                  personal: 0,
                  personalAmount: 0,
                  personal_history: [],
                  plan_duration: 0,
                  reason_surcharge_id: null,
                  routes: 0,
                  showname: res.name,
                  sum: 0,
                  sum_bonus: 0,
                  sum_calc: 0,
                  sum_departure: 0,
                  sum_deposit: 0,
                  sum_distance: 0,
                  sum_duration: 0,
                  sum_min: 0,
                  sum_orders: 0,
                  sum_paid: 0,
                  sum_penalty: 0,
                  sum_prepay: 0,
                  sum_round: 0,
                  sum_short_shift: 0,
                  sum_surcharge: 0,
                  worker_id: res.id,
                  worktime: 12,
                };

                this.data.period.drivers.workers.push(workerData);

                this.$emit("createNewWorker", workerData);
              } else {
                let s = null;
                if (this.rankLocalValue !== null) {
                  const c = this.postLocalItems.findIndex((item) => item.value === res.post_code);
                  if (c !== -1) {
                    const b = this.postLocalItems[c].categories.findIndex(
                      (category) => category.value === res.category_id,
                    );
                    if (b !== -1) s = this.postLocalItems[c].categories[b].s;
                  }
                }

                const workerData = {
                  bonus_id: 0,
                  bonuses: [],
                  category_id: res.category_id !== null ? res.category_id : 0,
                  category_number:
                    this.rankLocalValue !== null && this.rankLocalValue !== undefined ? this.rankLocalValue.label : 0,
                  count_products: 0,
                  count_smenas: 0,
                  fine_id: 0,
                  fines: [],
                  normday: 0,
                  personal: 0,
                  personal_history: [],
                  post_code: res.post_code,
                  s_kbonus: s !== null ? s.k_bonus : 0,
                  s_koutput: s !== null ? s.k_output : 0,
                  s_kpenaly: s !== null ? s.k_penalty : 0,
                  s_salary: s !== null ? s.salary : 0,
                  showname: res.name,
                  showpost: res.post,
                  sum: 0,
                  sum_bonus: 0,
                  sum_bonus_calc: 0,
                  sum_compens: 0,
                  sum_deposit: 0,
                  sum_surcharge: 0,
                  sum_paid: 0,
                  sum_penalty: 0,
                  sum_penalty_calc: 0,
                  sum_prepay: 0,
                  sum_round: 0,
                  sum_salary: 0,
                  worker_id: res.id,
                  worktime: 12,
                  worktime_correctly: 12,
                };

                this.data.period.production.workers.push(workerData);

                this.$emit("createNewWorker", workerData);
              }
            }else {
              for (var key in res) {
                if (!this.isDeliveryTab)
                  this.data.production[key] = res[key];
                else
                  this.data.allDrivers[key] = res[key];
                this.$emit("createNewWorker", {"key":key});
              }
            }

            this.closeModal();
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.m-create-worker {
  &-close {
    cursor: pointer;
    position: absolute;
    top: 14px;
    right: 12px;
  }

  &-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;
  }

  &-inputs {
    &-fullname {
      margin-top: 25px;

      @media screen and (max-width: 700px) {
        margin-top: 18px;
      }

      &-required {
        padding-bottom: 22px;
      }
    }

    &-row {
      margin-top: 25px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      @media screen and (max-width: 700px) {
        margin-top: 18px;
        align-items: flex-start;
        flex-direction: column;
      }

      &-post {
        width: 395px;

        @media screen and (max-width: 700px) {
          width: 100%;
        }

        &::v-deep .c-input-action_clear_active {
          margin-top: 1px;
        }

        &-required {
          @media screen and (max-width: 700px) {
            padding-bottom: 22px;
          }
        }
      }

      &-rank {
        width: 100px;

        @media screen and (max-width: 700px) {
          margin-top: 18px;
          width: 50%;
        }

        &::v-deep .c-input-action_clear_active {
          margin-top: 1px;
        }

        &-disabled {
          pointer-events: none;
          opacity: 0.5;
        }
      }
    }
  }

  &-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 40px;

    @media screen and (max-width: 700px) {
      width: 100%;
      box-shadow: 0px 0px 15px rgba(8, 20, 45, 0.3);
      position: fixed;
      bottom: 0;
      left: 0;
    }

    &-cancel {
      @media screen and (max-width: 700px) {
        width: 50%;
      }

      ::v-deep & .c-button__wrapper {
        height: 38px !important;

        @media screen and (max-width: 700px) {
          display: flex;
          justify-content: center;
          width: 100%;
          border-radius: 0;
        }
      }
    }

    &-save {
      margin-left: 10px;

      @media screen and (max-width: 700px) {
        margin-left: 0;
        width: 50%;
      }

      ::v-deep & .c-button__wrapper {
        height: 38px !important;

        @media screen and (max-width: 700px) {
          display: flex;
          justify-content: center;
          width: 100%;
          border-radius: 0;
        }
      }
    }
  }
}
</style>
